import { useEffect } from 'react';
import { logout } from '../../../core/services/auth/logout/logout.slice';
import { useAppDispatch } from '../../../core/services/hooks';

/**
 * Sifre belirleme derin linkine oturum acikken girildiginde calisir:
 * once cikis yapilir, sonra ayni adrese anonim olarak donulur.
 *
 * Mevcut path korunur: /new-password ve /copilot-new-password ayni sekilde calisir.
 */
export default function Logout() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // searchParams effect icinde okunuyor: her render'da yeni bir nesne
    // uretildigi icin bagimlilik listesine konursa effect sonsuz doner.
    const searchParams = new URLSearchParams(window.location.search);

    // logout thunk'i istek hatasini kendi yutuyor, her durumda resolve olur.
    dispatch(logout()).then(() => {
      window.location.replace(
        `${window.location.pathname}?${searchParams.toString()}`
      );
    });
  }, [dispatch]);

  return (
    <div className="flex items-center justify-center h-screen">
      <h1>Already logged in. Redirecting...</h1>
    </div>
  );
}
